module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Loader-164d418c8487f9bd86c9c71e70373ad9.svg";